import { render, staticRenderFns } from "./WorkoutLogHistoryStatistics.vue?vue&type=template&id=60a57444"
import script from "./WorkoutLogHistoryStatistics.vue?vue&type=script&lang=js"
export * from "./WorkoutLogHistoryStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports